import { Injectable } from '@angular/core';
import { SalesChannel } from 'src/app/core/consts/sales-channel.enum';
import { RestApiService } from './rest-api.service';
import { salesChannel } from 'src/app/core/utils/utils';
import { ApplicationStateService } from './application-state.service';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import {UrlParamsService} from '../../core/services/impl/url-params.service';
import {QueryParamName} from '../../core/enums/query-param-name.enum';

@Injectable({
  providedIn: 'root'
})
export class SalesChannelAnalyticsService {

  private readonly BANKIER_TOKEN = 'cEZHw0YzYnsP';
  private salesChannel: SalesChannel;
  private bankier_id: string;
  private paymentConfirmationRequestSent = false;

  get bankierId(): string {
    return this.bankier_id;
  }

  set bankierId(id: string) {
    this.bankier_id = id;
    this.stateService.bankierIdSalesChannelBankier = id;
  }

  constructor(private api: RestApiService,
    private urlParamsService: UrlParamsService,
    private stateService: ApplicationStateService) { }

  init() {
    if (!this.salesChannel) {
      this.salesChannel = <SalesChannel>salesChannel();
    }

    const bankierIdSalesChannelBankier = this.stateService.state.bankierIdSalesChannelBankier;
    if (isNotNullOrUndefined(bankierIdSalesChannelBankier)) {
      this.bankier_id = bankierIdSalesChannelBankier;
    }
  }

  sendDataForCurrentStep(stepIndex: number) {
    switch (stepIndex) {
      case 0:
        this.sendDataAfterFirstStep();
        break;
      case 3:
        this.sendDataAfterOfferSelect();
        break;
    }
  }

  sendDataAfterPaymentInit() {
    switch (this.salesChannel) {
      case SalesChannel.BANKIER:
        this.sendSaleRequestForBankier(1);
        break;
    }
  }

  sendDataAfterPaymentConfirmation() {
    if (!this.paymentConfirmationRequestSent) {
      switch (this.salesChannel) {
        case SalesChannel.BANKIER:
          this.sendSaleRequestForBankier(2);
          break;
      }
      this.paymentConfirmationRequestSent = true;
    }
  }

  private sendDataAfterFirstStep() {
    switch (this.salesChannel) {
      case SalesChannel.BANKIER:
        this.getBankierId();
        break;
    }
  }

  private sendDataAfterOfferSelect() {
    switch (this.salesChannel) {
      case SalesChannel.BANKIER:
        this.sendSignupRequestForBankier();
        break;
    }
  }


  /**
   * analytics requests for BANKIER sales channel
   */

  /**
   * this request is triggered by navigating to step 1b from step 1a
   */
  private getBankierId() {
    // retrieve bankier_id only it wasn't initialized before by session or state cache
    if (!isNotNullOrUndefined(this.bankier_id)) {
      const userPayload = this.urlParamsService.getQueryParam(QueryParamName.USER_PAYLOAD);

      let url = isNotNullOrUndefined(userPayload) ? `https://www.bankier.pl/e/lead/2293/?json_format=1&user_payload=${userPayload}` : 'https://www.bankier.pl/e/lead/2293/?json_format=1';

      this.api.get(url, {}, true)
        .then(resp => {
          this.bankierId = resp.bankier_id.toString();
        })
        .catch(err => {
          console.error(err);
        });
    }
  }

  /**
   * this request is triggered by selecting an offer
   */
  private sendSignupRequestForBankier() {
    let url = `https://www.bankier.pl/e/signup/${this.bankier_id}`;

    this.api.get(url, {}, true)
      .then()
      .catch(err => {
        console.error(err);
      });
  }

  /**
   * this request is triggered by payment initialization (saleStep = 1)
   * and confirmation (saleStep = 2)
   */
  private sendSaleRequestForBankier(saleStep: number) {
    let url = `https://www.bankier.pl/e/sale/${saleStep}/${this.BANKIER_TOKEN}/${this.bankier_id}/`;

    this.api.get(url, {}, true)
      .then()
      .catch(err => {
        console.error(err);
      });
  }
}
